"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GIFTING_ON_THE_FLY_ROUTES = void 0;

var _reactRouterDom = require("react-router-dom");

var GIFTING_ON_THE_FLY_ROUTES = {
  ENTRY_POINT: '/gifting-on-the-fly',
  CAMPAIGN_PATH: '/gifting-on-the-fly/:campaignId(\\d+)?',

  buildCampaignPath(campaignId) {
    return (0, _reactRouterDom.generatePath)(this.CAMPAIGN_PATH, {
      campaignId
    });
  }

};
exports.GIFTING_ON_THE_FLY_ROUTES = GIFTING_ON_THE_FLY_ROUTES;